import { getMajorMedCarrierTypeText } from "../../../../../lib/labels";
import { formatCurrency } from "../../../../../lib/script";
import CardGrey from "../../../../common/CardGrey";
import CheckboxCell from "../../../../common/interactive/CheckboxCell";
import SimpleBoxDisplay from "../../../../common/SimpleBoxDisplay";
import CaseSummaryBox from "../CaseSummaryBox";

export default function MajorMedicalSummary({primaryMajorMeds, classes}) {
    return <CaseSummaryBox title={'Major Medical'} tabNumber={5} type={'major_meds'}>
        {primaryMajorMeds && <>
            <div className={classes.row}>
                <SimpleBoxDisplay label={'Name'} value={primaryMajorMeds.insurance_carrier.name}/>
                <SimpleBoxDisplay label={'Type of Carrier'} value={getMajorMedCarrierTypeText(primaryMajorMeds.carrier_types)}/>
                <CardGrey>
                    <CheckboxCell checked={true} label={'PreAuth Required'} direction={'reverse'} setStyle={'box_small'} />
                </CardGrey>
            </div>
            <div className={classes.row}>                                
                <SimpleBoxDisplay label={'Office Copay'} value={`OON ${primaryMajorMeds.office_copay_oon ? '$' + formatCurrency(primaryMajorMeds.office_copay_oon) : '-'} - INN ${primaryMajorMeds.office_copay_inn ? '$' + formatCurrency(primaryMajorMeds.office_copay_inn) : '-'}`}/>
                <SimpleBoxDisplay label={'Deductibles'} value={`OON ${primaryMajorMeds.deductible_oon ? '$' + formatCurrency(primaryMajorMeds.deductible_oon) : '-'} - INN ${primaryMajorMeds.deductible_inn ? '$' + formatCurrency(primaryMajorMeds.deductible_inn) : '-'}`}/>
            </div>
        </>}
        {!primaryMajorMeds && <>No primary Major Medical selected!</>}
    </CaseSummaryBox>
}